import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import OverviewBoardActionsMultiple from '../ActionsMultiple';
import { ViewOptionsDropDown, TendersTotal, FilterStatuses, FilterSort } from 'src/shared';
import useSelectedTenders from 'src/reactiveVars/SelectedTendersVar';
import { useTendersViewState } from 'src/models/procurements/hooks';
import { PageView } from 'src/models/users/Preferences/types';

export const TendersBoardViewOptions: FC = () => {
  const [selectedTenders] = useSelectedTenders();
  const [currentView, setTendersView] = useTendersViewState();

  const toggleView = useCallback(
    (view: PageView) => {
      setTendersView(view);
    },
    [setTendersView]
  );

  return (
    <div className={styles.container}>
      <div className={!selectedTenders.length ? styles.isShown : styles.isHidden}>
        <TendersTotal />
      </div>
      <div className={selectedTenders.length ? styles.isShown : styles.isHidden}>
        <OverviewBoardActionsMultiple />
      </div>
      <ul className={styles.actions}>
        <li className={styles.action}>
          <FilterStatuses />
        </li>
        <li className={styles.action}>
          <FilterSort />
        </li>
        <li className={styles.action}>
          <ViewOptionsDropDown currentView={currentView} onToggleView={toggleView} />
        </li>
      </ul>
    </div>
  );
};

export default TendersBoardViewOptions;
